import React from "react";
import "../../../css/option.css";
import { default as ProductOption } from "./ProductOption";
import { filteredOptions, sortedOptions } from "../../../config/options";
import { pageType } from "../services/optionsHelpers";
import styled from "styled-components";
import {
  CANVAS_DEPTH,
  DIGITAL_PROOF,
  NEXT_DAY_SHIPPING,
  NEXT_DAY_SHIPPING_PROMO
} from "../../../constants/productOptions";

export default class ProductOptions extends React.Component {
  componentDidMount() {
    this.props.optionsUtility.fetchOptions();
    this.props.optionsUtility.fetchCartItems();
  }

  shouldShowOption = (option) => {
    if (
      option.handle === NEXT_DAY_SHIPPING ||
      option.handle === NEXT_DAY_SHIPPING_PROMO
    ) {
      return (
        (this.props.optionsUtility.shouldShowNDS ||
          this.props.optionsUtility.itemInCartHoldingDP) &&
        !this.props.optionsUtility.itemHasDP
      );
    } else if (option.handle === DIGITAL_PROOF) {
      return (
        (this.props.optionsUtility.shouldShowDP ||
          this.props.optionsUtility.itemInCartHoldingNDS) &&
        !this.props.optionsUtility.itemHasNDS
      );
    } else if (option.handle === CANVAS_DEPTH) {
      return !this.props.optionsUtility.largeFormat;
    } else {
      return true;
    }
  };

  hasProductOptions = () => {
    let options = filteredOptions(
      pageType,
      sortedOptions(this.props.optionsUtility.options),
      false
    );
    return options.length > 0;
  };

  render() {
    return (
      <>
        {this.hasProductOptions() && (
          <Container>
            {filteredOptions(
              pageType,
              sortedOptions(this.props.optionsUtility.filteredOptions),
              false
            ).map((option) => {
              return (
                this.shouldShowOption(option) && (
                  <ProductOption
                    key={option.label}
                    option={option}
                    optionsUtility={this.props.optionsUtility}
                  />
                )
              );
            })}
          </Container>
        )}
      </>
    );
  }
}
const Container = styled.div`
  width: 100%;
`;
